export const langGoogle = {
    "arm": {
        tr_or: "կամ",
        tr_continueWithGoogle: "Շարունակել Google-ով",
        tr_finishTitle: "Ավարտեք գրանցումը",
        tr_finishText(name) { return `Բարև, ${name}։ Գրանցումն ավարտելու համար լրացրեք Ձեր հեռախոսահամարը։` },
        tr_phoneNumber: "Հեռախոսահամար",
        tr_continue: "Շարունակել",
        tr_cancel: "Չեղարկել",
        tr_selectCode: "Ընտրեք երկրի կոդը ցուցակից",
        errors: {
            GOOGLE_INVALID: "Google-ով մուտքը չհաջողվեց, փորձեք կրկին",
            GOOGLE_EMAIL_UNVERIFIED: "Այս էլ․ հասցեով հաշիվ արդեն կա։ Մուտք գործեք Ձեր գաղտնաբառով",
            GOOGLE_NOT_CONFIGURED: "Google-ով մուտքը կարգավորված չէ",
            GOOGLE_LOGIN_FAILED: "Մուտքը չհաջողվեց, փորձեք կրկին",
            PHONE_INVALID: "Հեռախոսահամարը սխալ է",
            PHONE_TAKEN: "Այս հեռախոսահամարով օգտատեր արդեն գրանցված է",
        },
    },
    "eng": {
        tr_or: "or",
        tr_continueWithGoogle: "Continue with Google",
        tr_finishTitle: "Finish signing up",
        tr_finishText(name) { return `Hi ${name}! Enter your phone number to finish creating your account.` },
        tr_phoneNumber: "Phone number",
        tr_continue: "Continue",
        tr_cancel: "Cancel",
        tr_selectCode: "Select a country code from the list",
        errors: {
            GOOGLE_INVALID: "Google sign-in failed, please try again",
            GOOGLE_EMAIL_UNVERIFIED: "An account with this email already exists. Log in with your password",
            GOOGLE_NOT_CONFIGURED: "Google sign-in is not configured",
            GOOGLE_LOGIN_FAILED: "Login failed, please try again",
            PHONE_INVALID: "Phone number is not valid",
            PHONE_TAKEN: "This phone number is already registered",
        },
    },
    "fr": {
        tr_or: "ou",
        tr_continueWithGoogle: "Continuer avec Google",
        tr_finishTitle: "Terminer l'inscription",
        tr_finishText(name) { return `Bonjour ${name} ! Saisissez votre numéro de téléphone pour terminer la création de votre compte.` },
        tr_phoneNumber: "Numéro de téléphone",
        tr_continue: "Continuer",
        tr_cancel: "Annuler",
        tr_selectCode: "Choisissez un indicatif pays dans la liste",
        errors: {
            GOOGLE_INVALID: "La connexion avec Google a échoué, réessayez",
            GOOGLE_EMAIL_UNVERIFIED: "Un compte avec cet e-mail existe déjà. Connectez-vous avec votre mot de passe",
            GOOGLE_NOT_CONFIGURED: "La connexion avec Google n'est pas configurée",
            GOOGLE_LOGIN_FAILED: "La connexion a échoué, réessayez",
            PHONE_INVALID: "Le numéro de téléphone n'est pas valide",
            PHONE_TAKEN: "Ce numéro de téléphone est déjà enregistré",
        },
    },
    "arb": {
        tr_or: "أو",
        tr_continueWithGoogle: "المتابعة باستخدام Google",
        tr_finishTitle: "إكمال التسجيل",
        tr_finishText(name) { return `مرحبًا ${name}! أدخل رقم هاتفك لإكمال إنشاء حسابك.` },
        tr_phoneNumber: "رقم الهاتف",
        tr_continue: "متابعة",
        tr_cancel: "إلغاء",
        tr_selectCode: "اختر رمز الدولة من القائمة",
        errors: {
            GOOGLE_INVALID: "فشل تسجيل الدخول باستخدام Google، حاول مرة أخرى",
            GOOGLE_EMAIL_UNVERIFIED: "يوجد حساب بهذا البريد الإلكتروني بالفعل. سجّل الدخول بكلمة المرور",
            GOOGLE_NOT_CONFIGURED: "تسجيل الدخول باستخدام Google غير مُعد",
            GOOGLE_LOGIN_FAILED: "فشل تسجيل الدخول، حاول مرة أخرى",
            PHONE_INVALID: "رقم الهاتف غير صالح",
            PHONE_TAKEN: "رقم الهاتف هذا مسجل بالفعل",
        },
    },
    "rus": {
        tr_or: "или",
        tr_continueWithGoogle: "Продолжить с Google",
        tr_finishTitle: "Завершение регистрации",
        tr_finishText(name) { return `Здравствуйте, ${name}! Введите номер телефона, чтобы завершить создание аккаунта.` },
        tr_phoneNumber: "Номер телефона",
        tr_continue: "Продолжить",
        tr_cancel: "Отмена",
        tr_selectCode: "Выберите код страны из списка",
        errors: {
            GOOGLE_INVALID: "Не удалось войти через Google, попробуйте ещё раз",
            GOOGLE_EMAIL_UNVERIFIED: "Аккаунт с этим адресом эл. почты уже существует. Войдите с помощью пароля",
            GOOGLE_NOT_CONFIGURED: "Вход через Google не настроен",
            GOOGLE_LOGIN_FAILED: "Не удалось войти, попробуйте ещё раз",
            PHONE_INVALID: "Неверный номер телефона",
            PHONE_TAKEN: "Этот номер телефона уже зарегистрирован",
        },
    }
}
